import { render } from "./Form-Tag.vue?vue&type=template&id=96dac120"
import script from "./Form-Tag.vue?vue&type=script&lang=js"
export * from "./Form-Tag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__